var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"backgroud",attrs:{"src":require("@/assets/img/404.png"),"alt":""}}),_c('div',{staticClass:"text main-text"},[_vm._v("出错了...页面失踪了")]),_c('div',[_c('el-button',{staticClass:"text",attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){return _vm.back()}}},[_vm._v("返回")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }